import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
export function renderProviderSidePanel({ providers, selectedIndex, state, onSelect, }) {
    switch (state.status) {
        case 'loading':
            if (state.rows.length === 0) {
                return providers
                    .find((provider) => provider.renderSidePanel !== undefined)
                    ?.renderSidePanel?.({ status: 'loading' });
            }
            break;
        case 'done':
            break;
        case 'idle':
        case 'empty':
        case 'error':
            return undefined;
        default:
            return assertUnreachableValue(state);
    }
    if (selectedIndex === null) {
        return undefined;
    }
    const row = state.rows[selectedIndex];
    if (row === undefined) {
        return undefined;
    }
    const provider = providers[row.providerIndex];
    if (provider === undefined || provider.renderSidePanel === undefined) {
        return undefined;
    }
    let selected = false;
    const select = () => {
        if (selected || row.item.disabled === true)
            return;
        // A provider can retain this callback; never dispatch the same activation twice.
        selected = true;
        onSelect({ row, provider, flatIndex: selectedIndex });
    };
    return provider.renderSidePanel({
        status: 'ready',
        item: row.item,
        select,
    });
}
//# sourceMappingURL=typeaheadSidePanel.js.map